import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const payHistorySlice = createSlice({
  name: "payHistory",

  initialState: { payHistory: [] },
  reducers: {
    setPayHistory: (state: any, action: PayloadAction<any>) => {
      state.payHistory = action.payload;
    },

    resetPayHistory: (state: any) => {
      state = [];
    },
  },
});

export const { setPayHistory, resetPayHistory } = payHistorySlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default payHistorySlice.reducer;
